import { html } from 'lit'

import { FieldRenderer } from '../types'

export const OxGristRendererPassword: FieldRenderer = (value, column, record, rowIndex, field) => {
  return html`<span>********</span>`
}
